import { useEffect, useRef, useState } from "react";
import {
  Badge,
  Button,
  ButtonGroup,
  Dropdown,
  Modal,
  OverlayTrigger,
  Popover,
  Tooltip,
} from "react-bootstrap";
import { CustomTooltip } from "../../utils/helpers/custom-tooltip";
import ButtonBasic from "../../components/Buttons/ButtonBasic";
import LoaderComponent from "../../components/Spinner/LoaderComponent";
import axiosInstance from "../../utils/axiosInstance";
import _ from "lodash";
import Toast from "../../components/Toast/Toast";
import moment from "moment";
import { useDateTime } from "../../components/Helper/DateTime";
import { parseRawData, RawDataTooltip } from "./RawDataParser/RawDataParser";

export const LocateTransactionModal = ({ showModal, setShowModal, data }) => {
  const { date, setPresistState } = useDateTime();
  const { search } = window.location;
  const urlParams = new URLSearchParams(search);
  const dsAId = urlParams.get("from");
  const dsBId = urlParams.get("to");
  const tableWrapDSA = useRef(null);
  const tableWrapDSB = useRef(null);
  const [notes, setNotes] = useState([]);
  const [noteFlag, setNoteFlag] = useState(false);
  const [searchQueryDSA, setSearchQueryDSA] = useState("");
  const [tempSearchDSA, setTempSearchDSA] = useState("");
  const [searchQueryDSB, setSearchQueryDSB] = useState("");
  const [tempSearchDSB, setTempSearchDSB] = useState("");
  const [searchedTransactionDSA, setSearchedTransactionDSA] = useState([]);
  const [searchedTransactionDSB, setSearchedTransactionDSB] = useState([]);
  const [searchedHeaderDSA, setSearchedHeaderDSA] = useState([]);
  const [searchedHeaderDSB, setSearchedHeaderDSB] = useState([]);
  const [selectedTransactionDSA, setSelectedTransactionDSA] = useState([]);
  const [selectedTransactionDSB, setSelectedTransactionDSB] = useState([]);
  const [previousTransaction, setPreviousTransaction] = useState({
    dsA: [],
    dsB: [],
  });
  const [selectedColumnsDSA, setSelectedColumnsDSA] = useState([]);
  const [isOpenDSA, setIsOpenDSA] = useState(false);
  const [selectedColumnsDSB, setSelectedColumnsDSB] = useState([]);
  const [isOpenDSB, setIsOpenDSB] = useState(false);
  const [loaderDSA, setLoaderDSA] = useState(false);
  const [loaderDSB, setLoaderDSB] = useState(false);
  const [pageDSA, setPageDSA] = useState(0);
  const [totalPagesDSA, setTotalPagesDSA] = useState(0);
  const [pageDSB, setPageDSB] = useState(0);
  const [totalPagesDSB, setTotalPagesDSB] = useState(0);
  const [difference, setDifference] = useState(0);
  const [total, setTotal] = useState(0);

  const resetDSASearch = () => {
    setPageDSA(0);
    setSearchedTransactionDSA([]);
    setSearchQueryDSA("");
    setTempSearchDSA("");
    setSelectedColumnsDSA([]);
  };

  const resetDSBSearch = () => {
    setPageDSB(0);
    setSearchedTransactionDSB([]);
    setSearchQueryDSB("");
    setTempSearchDSB("");
    setSelectedColumnsDSB([]);
  };

  const dsASearches = (page, searchQuery) => {
    setLoaderDSA(true);
    const reconId = data?.reconId;
    const recon_account_id = data?.reconAccountId;
    const pair_id = data?.datasourceId;
    const output_id = data?.locateTransactions?.dsA?.[0]?.aggregateTxnId;
    const searchParams = new URLSearchParams();

    // Apply only one criteria at a time
    if (searchQuery) {
      // Clear column filters if search query is present
      setSelectedColumnsDSA([]);
    } else if (selectedColumnsDSA.length > 0) {
      // Apply column filters only if no search query
      selectedColumnsDSA.forEach((key) => {
        const column = data?.column1?.find((col) => col?.dataField === key);
        if (!column) return;

        const columnText = column.text;
        const correspondingColumn = data?.column2?.find(
          (col) => col?.text === columnText
        );
        if (!correspondingColumn) return;

        const transactionValue =
          data?.locateTransactions?.dsB?.[0]?.[correspondingColumn.dataField];
        if (transactionValue && transactionValue !== "N/A") {
          searchParams.append(`search_${key}`, transactionValue);
        }
      });
    } else if (!searchQuery && selectedColumnsDSA.length === 0) {
      setSearchedTransactionDSA([...selectedTransactionDSA]);
      setLoaderDSA(false);
      return;
    }

    let url = `/recon/fetch-pair-data/${reconId}?recon_account_id=${recon_account_id}&datasourceA_id=${dsAId}${
      searchQuery ? "&search=" + searchQuery : ""
    }&is_locate_txn_flow=true&output_id=${output_id}&pair_id=${pair_id}&page=${page}&size=${15}${
      searchParams?.size > 0 ? "&" + searchParams : ""
    }`;

    axiosInstance
      .get(url)
      .then((res) => {
        if (res.message.status !== "200") {
          setLoaderDSA(false);
          Toast(res?.message?.description, "error");
        } else {
          if (res?.data) {
            setSearchedTransactionDSA((prevState) => {
              const filteredPrevState = prevState.filter(
                (transaction) =>
                  !selectedTransactionDSA.some((selectedTransaction) =>
                    _.isEqual(selectedTransaction, transaction)
                  )
              );

              const filteredNewTransactions = res?.data?.transactions.filter(
                (transaction) =>
                  !selectedTransactionDSA.some((selectedTransaction) =>
                    _.isEqual(selectedTransaction, transaction)
                  )
              );

              return [
                ...selectedTransactionDSA,
                ...filteredPrevState,
                ...filteredNewTransactions,
              ];
            });
            setPreviousTransaction((prevState) => ({
              dsA: res.data.transactions,
              dsB: prevState.dsB,
            }));
            setSearchedHeaderDSA(res.data.headers);
            setPageDSA(res.page.number || 0);
            setTotalPagesDSA(res.page.totalPages || 0);
          } else if (res?.data === null) {
            setTotalPagesDSA(-1);
          }
        }
        setLoaderDSA(false);
      })
      .catch((err) => {
        setLoaderDSA(false);
      });
  };

  const dsBSearches = (page, searchQuery) => {
    setLoaderDSB(true);
    const reconId = data?.reconId;
    const recon_account_id = data?.reconAccountId;
    const pair_id = data?.datasourceId;
    const output_id = data?.locateTransactions?.dsB?.[0]?.aggregateTxnId;
    const searchParams = new URLSearchParams();

    // Apply only one criteria at a time
    if (searchQuery) {
      // Clear column filters if search query is present
      setSelectedColumnsDSB([]);
    } else if (selectedColumnsDSB.length > 0) {
      // Apply column filters only if no search query
      selectedColumnsDSB.forEach((key) => {
        const column = data?.column2?.find((col) => col?.dataField === key);
        if (!column) return;

        const columnText = column.text;
        const correspondingColumn = data?.column1?.find(
          (col) => col?.text === columnText
        );
        if (!correspondingColumn) return;

        const transactionValue =
          data?.locateTransactions?.dsA?.[0]?.[correspondingColumn.dataField];
        if (transactionValue && transactionValue !== "N/A") {
          searchParams.append(`search_${key}`, transactionValue);
        }
      });
    } else if (!searchQuery && selectedColumnsDSB.length === 0) {
      setSearchedTransactionDSB([...selectedTransactionDSB]);
      setLoaderDSB(false);
      return;
    }

    let url = `/recon/fetch-pair-data/${reconId}?recon_account_id=${recon_account_id}&datasourceB_id=${dsBId}${
      searchQuery ? "&search=" + searchQuery : ""
    }&is_locate_txn_flow=true&output_id=${output_id}&pair_id=${pair_id}&page=${page}&size=${15}${
      searchParams?.size > 0 ? "&" + searchParams : ""
    }`;

    axiosInstance
      .get(url)
      .then((res) => {
        if (res.message.status !== "200") {
          setLoaderDSB(false);
          Toast(res?.message?.description, "error");
        } else {
          if (res?.data) {
            setSearchedTransactionDSB((prevState) => {
              const filteredPrevState = prevState.filter(
                (transaction) =>
                  !selectedTransactionDSB.some((selectedTransaction) =>
                    _.isEqual(selectedTransaction, transaction)
                  )
              );

              const filteredNewTransactions = res?.data?.transactions.filter(
                (transaction) =>
                  !selectedTransactionDSB.some((selectedTransaction) =>
                    _.isEqual(selectedTransaction, transaction)
                  )
              );
              return [
                ...selectedTransactionDSB,
                ...filteredPrevState,
                ...filteredNewTransactions,
              ];
            });
            setPreviousTransaction((prevState) => ({
              dsA: prevState.dsA,
              dsB: res.data.transactions || [],
            }));
            setSearchedHeaderDSB(res.data.headers);
            setPageDSB(res.page.number || 0);
            setTotalPagesDSB(res.page.totalPages || 0);
          } else if (res?.data === null) {
            setTotalPagesDSB(-1);
          }
        }
        setLoaderDSB(false);
      })
      .catch((err) => {
        setLoaderDSB(false);
      });
  };

  const formatNumber = (number) => {
    if (isNaN(Number(number))) {
      return number;
    } else {
      number = Number(number);
      return number.toLocaleString(undefined, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        useGrouping: true,
      });
    }
  };

  const handleScrollDSA = (e) => {
    const el = e?.target;

    if (el?.scrollTop === 0) return;

    const nearBottom =
      Math.ceil(el?.scrollHeight - el?.scrollTop) <=
      Math.ceil(el?.clientHeight) + 2;

    if (nearBottom && pageDSA < totalPagesDSA - 1) {
      if (searchQueryDSA !== "" || selectedColumnsDSA?.length > 0) {
        dsASearches(pageDSA + 1, searchQueryDSA);
      }
    }
  };

  const handleScrollDSB = (e) => {
    const el = e.target;
    if (el?.scrollTop === 0) return;

    const nearBottom =
      Math.ceil(el?.scrollHeight - el?.scrollTop) <=
      Math.ceil(el?.clientHeight) + 2;

    if (nearBottom && pageDSB < totalPagesDSB - 1) {
      if (searchQueryDSB !== "" || selectedColumnsDSB?.length > 0) {
        dsBSearches(pageDSB + 1, searchQueryDSB);
      }
    }
  };

  useEffect(() => {
    let leftTxns = 0;
    let rightTxns = 0;
    let leftTotal = 0;
    let rightTotal = 0;
    data?.manualMatchingHeaders?.forEach((key) => {
      const field1 = data?.column1?.find(
        (column) => column.text?.toLowerCase() === key?.toLowerCase()
      )?.dataField;
      const field2 = data?.column2?.find(
        (column) => column.text?.toLowerCase() === key?.toLowerCase()
      )?.dataField;

      selectedTransactionDSA?.forEach((item) => {
        leftTxns += item[key] && !isNaN(item[key]) ? parseFloat(item[key]) : 0;
        leftTotal += item[key] && !isNaN(item[key]) ? parseFloat(item[key]) : 0;
      });

      data?.locateTransactions?.dsA?.forEach((item) => {
        leftTxns +=
          item[field1] && !isNaN(item[field1]) ? parseFloat(item[field1]) : 0;
      });

      selectedTransactionDSB?.forEach((item) => {
        rightTxns += item[key] && !isNaN(item[key]) ? parseFloat(item[key]) : 0;
        rightTotal +=
          item[key] && !isNaN(item[key]) ? parseFloat(item[key]) : 0;
      });

      data?.locateTransactions?.dsB?.forEach((item) => {
        rightTxns +=
          item[field2] && !isNaN(item[field2]) ? parseFloat(item[field2]) : 0;
      });
    });
    setTotal(
      data?.isAccountingRecon ? leftTotal + rightTotal : leftTotal - rightTotal
    );
    setDifference(() =>
      data?.isAccountingRecon ? leftTxns + rightTxns : leftTxns - rightTxns
    );
  }, [selectedTransactionDSA, selectedTransactionDSB]);

  const addNote = () => {
    let now = moment();
    let comment = document.getElementById("note").value;
    if (comment !== "") {
      let note = {
        comment: comment,
        author: `${JSON.parse(localStorage.getItem("userData")).firstName} ${
          JSON.parse(localStorage.getItem("userData")).lastName
        }`,
        date: now.format(date),
        time: now.hour() + ":" + now.minute(),
      };
      setNotes((prevState) => [...prevState, note]);
      document.getElementById("note").value = "";
      setNoteFlag(true);
    }
  };

  const bindLocatedTransaction = () => {
    const body = {
      data: {
        pairId: data?.datasourceId,
        targetOutputId:
          data?.locateTransactions?.dsA?.[0]?.aggregateTxnId ??
          data?.locateTransactions?.dsB?.[0]?.aggregateTxnId,
        reconConfigId: data?.reconId,
        locatedTransactions: [
          ...(selectedTransactionDSA || []).map((txn) => ({
            sourceOutputId: txn?.outputid ?? null,
            transactionId: txn?.id,
            datasourceId: dsAId,
          })),
          ...(selectedTransactionDSB || []).map((txn) => ({
            sourceOutputId: txn?.outputid ?? null,
            transactionId: txn?.id,
            datasourceId: dsBId,
          })),
        ],
        notes: data?.notes ? [...data?.notes, ...notes] : notes,
        payload: {
          dsA: data?.datasourceA,
          dsB: data?.datasourceB,
          manualMatchTransaction: [
            {
              matching_flow: "Bind-Located-Transaction-ADC",
              matchStatus: data?.status,
              missingTxn: selectedTransactionDSA?.length > 0 ? "DSA" : "DSB",
              headers: {
                txnHeaders:
                  selectedTransactionDSA?.length > 0
                    ? data?.column2?.map((column) => column.text)
                    : data?.column1?.map((column) => column.text),
                txnColumns:
                  selectedTransactionDSA?.length > 0
                    ? data?.column2?.map((column) => column.dataField)
                    : data?.column1?.map((column) => column.dataField),
                locatedTxnHeaders:
                  searchedHeaderDSA.length > 0
                    ? searchedHeaderDSA
                    : searchedHeaderDSB.length > 0
                    ? searchedHeaderDSB
                    : [],
                locatedTxnColumns:
                  searchedHeaderDSA.length > 0
                    ? searchedHeaderDSA
                    : searchedHeaderDSB.length > 0
                    ? searchedHeaderDSB
                    : [],
              },
              matchingData: [
                [
                  ...(data?.column1?.every(
                    (column) =>
                      data?.locateTransactions?.dsA?.[0]?.[
                        column?.dataField
                      ] === "N/A"
                  )
                    ? []
                    : data?.locateTransactions?.dsA || []),
                  ...selectedTransactionDSA,
                ],
                [
                  ...(data?.column2?.every(
                    (column) =>
                      data?.locateTransactions?.dsB?.[0]?.[
                        column?.dataField
                      ] === "N/A"
                  )
                    ? []
                    : data?.locateTransactions?.dsB || []),
                  ...selectedTransactionDSB,
                ],
              ],
            },
          ],
        },
      },
    };

    axiosInstance
      .post("/recon/bind-located-transaction", body)
      .then((res) => {
        if (res?.message?.status === "200") {
          Toast(res?.message?.description, "success");
          resetDSASearch();
          resetDSBSearch();
          setSelectedTransactionDSA([]);
          setSelectedTransactionDSB([]);
          setDifference(0);
          setTotal(0);
          setShowModal(false);
        } else {
          Toast(res?.message?.description, "error");
        }
      })
      .catch((err) => {
        Toast(
          err?.response?.data?.message?.description ||
            "Error binding transactions",
          "error"
        );
      });
  };

  // Check if save should be enabled based on locateTxnEnforceDiff
  const isSaveEnabled = () => {
    const hasNotes = notes?.length > 0 && noteFlag;
    const hasSelectedTxn =
      selectedTransactionDSA.length > 0 || selectedTransactionDSB.length > 0;
    if (data?.locateTxnEnforceDiff) {
      // When enforceDiff is true, difference must be 0 AND notes must be added
      return hasNotes && difference === 0;
    } else if (data?.locateTxnEnforceDiff === false) {
      // When enforceDiff is false, select any transaction AND notes must be added
      return hasNotes && hasSelectedTxn;
    } else {
      // When enforceDiff is false, only notes are required
      return hasNotes;
    }
  };

  // Get appropriate disabled message based on locateTxnEnforceDiff
  const getDisabledMessage = () => {
    const hasSelectedTxn =
      selectedTransactionDSA.length > 0 || selectedTransactionDSB.length > 0;
    if (data?.locateTxnEnforceDiff && difference !== 0) {
      return "Difference should be 0";
    }
    if (data?.locateTxnEnforceDiff === false && !hasSelectedTxn) {
      return "Select a transaction for binding";
    }
    if (!noteFlag || notes?.length === 0) {
      return "Add Notes";
    }
    return "";
  };

  return (
    <Modal
      backdrop={true}
      size="xl"
      show={showModal}
      onHide={() => {
        resetDSASearch();
        resetDSBSearch();
        setSelectedTransactionDSA([]);
        setSelectedTransactionDSB([]);
        setDifference(0);
        setTotal(0);
        setShowModal(false);
      }}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <Modal.Header closeButton>Locate Transaction</Modal.Header>
      <Modal.Body scrollable="true">
        <div className="row">
          <div className="col-8">
            <div className="row mt-4">
              <div className="col-12">
                <div className="d-flex justify-content-between">
                  <div className="text-info">{data?.datasourceA}</div>
                  {data?.dsALocateTxnSearch &&
                    data?.locateTransactions?.dsA?.every((item) =>
                      data?.column1?.every(
                        (column) =>
                          item[column?.dataField] === null ||
                          item[column?.dataField] === "N/A"
                      )
                    ) && (
                      <div className="d-flex align-items-center">
                        <div className="has-search">
                          <span className="fa fa-search form-control-feedback"></span>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search"
                            value={tempSearchDSA}
                            onChange={(e) => {
                              setTempSearchDSA(e.target.value);
                              if (e.target.value === "") {
                                setSearchQueryDSA("");
                              }
                            }}
                            onKeyUp={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                setPreviousTransaction((prevState) => {
                                  return {
                                    ...prevState,
                                    dsA: [],
                                  };
                                });
                                setSearchedTransactionDSA([]);
                                setSearchQueryDSA(tempSearchDSA);
                                dsASearches(0, tempSearchDSA);
                              }
                            }}
                            disabled={loaderDSA}
                          />
                        </div>

                        <Dropdown
                          as={ButtonGroup}
                          show={isOpenDSA}
                          onToggle={(isOpen, event, metadata) => {
                            if (metadata.source === "select") return;
                            setIsOpenDSA(isOpen);
                          }}
                        >
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip>
                                {loaderDSA
                                  ? "Applying..."
                                  : "Filter based on selected columns"}
                              </Tooltip>
                            }
                          >
                            <Dropdown.Toggle
                              variant="link"
                              className="d-flex align-items-center justify-content-center"
                              disabled={loaderDSA}
                            >
                              <i className="fa fa-columns"></i>
                            </Dropdown.Toggle>
                          </OverlayTrigger>

                          <Dropdown.Menu
                            className="shadow-lg border-0 p-0"
                            style={{ minWidth: "280px" }}
                          >
                            <div className="px-3 py-2 border-bottom bg-light rounded-top">
                              <div className="d-flex justify-content-between align-items-center">
                                <h6 className="mb-0 font-weight-bold">
                                  Select Columns
                                </h6>
                                <Badge pill variant="info" className="px-2">
                                  {selectedColumnsDSA.length} selected
                                </Badge>
                              </div>
                            </div>

                            <div
                              className="px-2 py-2"
                              style={{ maxHeight: "300px", overflowY: "auto" }}
                            >
                              {data?.column1?.map((column) => {
                                const isSelected = selectedColumnsDSA.includes(
                                  column.dataField
                                );
                                return (
                                  <Dropdown.Item
                                    key={column.dataField}
                                    as="button"
                                    className={`d-flex align-items-center py-2 px-3 rounded ${
                                      isSelected ? "bg-primary-light" : ""
                                    }`}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setSelectedColumnsDSA((prev) =>
                                        isSelected
                                          ? prev.filter(
                                              (item) =>
                                                item !== column.dataField
                                            )
                                          : [...prev, column.dataField]
                                      );
                                    }}
                                  >
                                    <div
                                      className={`mr-2 d-flex align-items-center justify-content-center ${
                                        isSelected
                                          ? "text-primary"
                                          : "text-muted"
                                      }`}
                                    >
                                      {isSelected ? (
                                        <i className="fa fa-check-circle"></i>
                                      ) : (
                                        <i className="fa fa-circle"></i>
                                      )}
                                    </div>
                                    <span
                                      className={
                                        isSelected ? "font-weight-bold" : ""
                                      }
                                    >
                                      {column.text}
                                    </span>
                                  </Dropdown.Item>
                                );
                              })}
                            </div>

                            <div className="px-3 py-2 border-top bg-light rounded-bottom">
                              <Button
                                variant="primary"
                                block
                                className="rounded-pill d-flex align-items-center justify-content-center py-2"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setPreviousTransaction((prevState) => {
                                    return {
                                      ...prevState,
                                      dsA: [],
                                    };
                                  });
                                  setSearchedTransactionDSA([]);
                                  setTempSearchDSA("");
                                  setSearchQueryDSA("");
                                  dsASearches(0, "");
                                  setIsOpenDSA(false);
                                }}
                                disabled={loaderDSA}
                              >
                                <i className="fa fa-check-circle mr-2"></i>
                                Apply Selection
                              </Button>
                            </div>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    )}
                </div>
                {loaderDSA ? (
                  <div
                    className="d-flex justify-content-center mt-5"
                    style={{ height: "100px" }}
                  >
                    <LoaderComponent />
                  </div>
                ) : (
                  <div
                    className={`table-responsive mt-1 mb-4 fancy-scroll`}
                    ref={tableWrapDSA}
                    onScroll={handleScrollDSA}
                    style={{ maxHeight: "300px", overflow: "auto" }}
                  >
                    <table
                      className={`table table-dim-dark table-bordered table-custom-style m-0`}
                    >
                      <thead>
                        <tr>
                          <th></th>
                          {searchedTransactionDSA?.length > 0
                            ? searchedHeaderDSA?.length > 0 &&
                              searchedHeaderDSA?.map((column) => (
                                <th
                                  key={column}
                                  className={`text-info ${
                                    column === "Amount" ? "text-right" : ""
                                  }`}
                                  style={
                                    selectedColumnsDSA.includes(
                                      data?.column1?.find(
                                        (col) => col?.text === column
                                      )?.dataField
                                    )
                                      ? { backgroundColor: "#f5f6f7" }
                                      : {}
                                  }
                                >
                                  {column}
                                </th>
                              ))
                            : data?.column1?.map((column) => (
                                <th
                                  key={column.dataField}
                                  className={`text-info ${
                                    column?.text === "Amount"
                                      ? "text-right"
                                      : ""
                                  }`}
                                  style={
                                    selectedColumnsDSA.includes(
                                      column?.dataField
                                    )
                                      ? { backgroundColor: "#f5f6f7" }
                                      : {}
                                  }
                                >
                                  {column?.text}
                                </th>
                              ))}
                        </tr>
                      </thead>

                      <tbody>
                        {data?.locateTransactions?.dsA?.map((item, index) => {
                          const rowHasValue = data?.column1?.some(
                            (col) =>
                              item[col.dataField] !== "N/A" &&
                              item[col.dataField] !== undefined &&
                              item[col.dataField] !== null
                          );
                          if (!rowHasValue) {
                            return null;
                          }

                          return (
                            <tr key={`dsa-original-${index}`}>
                              <td></td>
                              {data?.column1?.map(({ text, dataField }) => {
                                const value = item[dataField];
                                const isAmount = text === "Amount" && value;
                                const formattedValue = isAmount
                                  ? formatNumber(value)
                                  : value;
                                return (
                                  <td
                                    key={dataField}
                                    className={isAmount ? "text-right" : ""}
                                    style={
                                      selectedColumnsDSA.includes(dataField)
                                        ? { backgroundColor: "#f5f6f7" }
                                        : {}
                                    }
                                  >
                                    {formattedValue ?? ""}
                                  </td>
                                );
                              })}
                            </tr>
                          );
                        })}
                        {searchedTransactionDSA?.length > 0 &&
                          searchedTransactionDSA?.map((item, index) => (
                            <tr key={`dsa-searched-${index}`}>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={_.isEqual(
                                    selectedTransactionDSA?.[0],
                                    item
                                  )}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setSelectedTransactionDSA([item]);
                                    } else {
                                      setSelectedTransactionDSA([]);
                                    }
                                  }}
                                />
                              </td>
                              {searchedHeaderDSA?.map((header) => {
                                if (header?.toLowerCase() === "raw data") {
                                  const rawDataContent = item[header];
                                  const parsedPreview =
                                    parseRawData(rawDataContent);
                                  const displayContent =
                                    parsedPreview.length > 50
                                      ? parsedPreview.substring(0, 50) + "..."
                                      : parsedPreview;

                                  return (
                                    <td
                                      key={header}
                                      style={
                                        selectedColumnsDSA.includes(
                                          data?.column1?.find(
                                            (col) => col?.text === header
                                          )?.dataField
                                        )
                                          ? { backgroundColor: "#f5f6f7" }
                                          : {}
                                      }
                                    >
                                      {displayContent ? (
                                        <OverlayTrigger
                                          trigger="click"
                                          placement="left"
                                          overlay={
                                            <Popover id="popover-basic">
                                              <RawDataTooltip
                                                rawData={rawDataContent}
                                              />
                                            </Popover>
                                          }
                                          rootClose
                                        >
                                          <Button
                                            variant="link"
                                            className="p-0 text-left raw-data-preview"
                                            style={{
                                              textDecoration: "none",
                                              color: "#007bff",
                                              cursor: "pointer",
                                              fontSize: "12px",
                                              fontFamily: "monospace",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              maxWidth: "200px",
                                              display: "block",
                                            }}
                                          >
                                            {displayContent}
                                          </Button>
                                        </OverlayTrigger>
                                      ) : (
                                        "-"
                                      )}
                                    </td>
                                  );
                                } else {
                                  return (
                                    <td
                                      key={header}
                                      style={
                                        selectedColumnsDSA.includes(
                                          data?.column1?.find(
                                            (col) => col?.text === header
                                          )?.dataField
                                        )
                                          ? { backgroundColor: "#f5f6f7" }
                                          : {}
                                      }
                                    >
                                      {item?.[header] || "-"}
                                    </td>
                                  );
                                }
                              })}
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                )}
                <div className="d-flex justify-content-between">
                  <div className="text-danger">{data?.datasourceB}</div>

                  {data?.dsBLocateTxnSearch &&
                    data?.locateTransactions?.dsB?.every((item) =>
                      data?.column2?.every(
                        (column) =>
                          item[column?.dataField] === null ||
                          item[column?.dataField] === "N/A"
                      )
                    ) && (
                      <div className="d-flex align-items-center">
                        <div className="has-search">
                          <span className="fa fa-search form-control-feedback"></span>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search"
                            value={tempSearchDSB}
                            onChange={(e) => {
                              setTempSearchDSB(e.target.value);
                              if (e.target.value === "") {
                                setSearchQueryDSB("");
                              }
                            }}
                            onKeyUp={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                setPreviousTransaction((prevState) => {
                                  return {
                                    ...prevState,
                                    dsB: [],
                                  };
                                });
                                setSearchedTransactionDSB([]);
                                setSearchQueryDSB(tempSearchDSB);
                                dsBSearches(0, tempSearchDSB);
                              }
                            }}
                            disabled={loaderDSB}
                          />
                        </div>

                        <Dropdown
                          as={ButtonGroup}
                          show={isOpenDSB}
                          onToggle={(isOpen, event, metadata) => {
                            if (metadata.source === "select") return;
                            setIsOpenDSB(isOpen);
                          }}
                        >
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip>
                                {loaderDSB
                                  ? "Applying..."
                                  : "Filter based on selected columns"}
                              </Tooltip>
                            }
                          >
                            <Dropdown.Toggle
                              variant="link"
                              className="d-flex align-items-center justify-content-center"
                              disabled={loaderDSB}
                            >
                              <i className="fa fa-columns"></i>
                            </Dropdown.Toggle>
                          </OverlayTrigger>

                          <Dropdown.Menu
                            className="shadow-lg border-0 p-0"
                            style={{ minWidth: "280px" }}
                          >
                            <div className="px-3 py-2 border-bottom bg-light rounded-top">
                              <div className="d-flex justify-content-between align-items-center">
                                <h6 className="mb-0 font-weight-bold">
                                  Select Columns
                                </h6>
                                <Badge pill variant="info" className="px-2">
                                  {selectedColumnsDSB.length} selected
                                </Badge>
                              </div>
                            </div>

                            <div
                              className="px-2 py-2"
                              style={{ maxHeight: "300px", overflowY: "auto" }}
                            >
                              {data?.column2?.map((column) => {
                                const isSelected = selectedColumnsDSB.includes(
                                  column.dataField
                                );
                                return (
                                  <Dropdown.Item
                                    key={column.dataField}
                                    as="button"
                                    className={`d-flex align-items-center py-2 px-3 rounded ${
                                      isSelected ? "bg-primary-light" : ""
                                    }`}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setSelectedColumnsDSB((prev) =>
                                        isSelected
                                          ? prev.filter(
                                              (item) =>
                                                item !== column.dataField
                                            )
                                          : [...prev, column.dataField]
                                      );
                                    }}
                                  >
                                    <div
                                      className={`mr-2 d-flex align-items-center justify-content-center ${
                                        isSelected
                                          ? "text-primary"
                                          : "text-muted"
                                      }`}
                                    >
                                      {isSelected ? (
                                        <i className="fa fa-check-circle"></i>
                                      ) : (
                                        <i className="fa fa-circle"></i>
                                      )}
                                    </div>
                                    <span
                                      className={
                                        isSelected ? "font-weight-bold" : ""
                                      }
                                    >
                                      {column.text}
                                    </span>
                                  </Dropdown.Item>
                                );
                              })}
                            </div>

                            <div className="px-3 py-2 border-top bg-light rounded-bottom">
                              <Button
                                variant="primary"
                                block
                                className="rounded-pill d-flex align-items-center justify-content-center py-2"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setPreviousTransaction((prevState) => {
                                    return {
                                      ...prevState,
                                      dsB: [],
                                    };
                                  });
                                  setSearchedTransactionDSB([]);
                                  setTempSearchDSB("");
                                  setSearchQueryDSB("");
                                  dsBSearches(0, "");
                                  setIsOpenDSB(false);
                                }}
                                disabled={loaderDSB}
                              >
                                <i className="fa fa-check-circle mr-2"></i>
                                Apply Selection
                              </Button>
                            </div>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    )}
                </div>
                {loaderDSB ? (
                  <div
                    className="d-flex justify-content-center mt-5"
                    style={{ height: "100px" }}
                  >
                    <LoaderComponent />
                  </div>
                ) : (
                  <div
                    className={`table-responsive mt-1 fancy-scroll`}
                    ref={tableWrapDSB} // <── ref
                    onScroll={handleScrollDSB}
                    style={{ maxHeight: "300px", overflow: "auto" }}
                  >
                    <table
                      className={`table table-dim-dark table-bordered table-custom-style m-0`}
                    >
                      <thead>
                        <tr>
                          <th></th>
                          {searchedTransactionDSB?.length > 0
                            ? searchedHeaderDSB?.length > 0 &&
                              searchedHeaderDSB?.map((column) => (
                                <th
                                  key={column}
                                  className={`text-info ${
                                    column === "Amount" ? "text-right" : ""
                                  }`}
                                  style={
                                    selectedColumnsDSB.includes(
                                      data?.column2?.find(
                                        (col) => col?.text === column
                                      )?.dataField
                                    )
                                      ? { backgroundColor: "#f5f6f7" }
                                      : {}
                                  }
                                >
                                  {column}
                                </th>
                              ))
                            : data?.column2?.map((column) => (
                                <th
                                  key={column.dataField}
                                  className={`text-info ${
                                    column?.text === "Amount"
                                      ? "text-right"
                                      : ""
                                  }`}
                                  style={
                                    selectedColumnsDSB.includes(
                                      column?.dataField
                                    )
                                      ? { backgroundColor: "#f5f6f7" }
                                      : {}
                                  }
                                >
                                  {column?.text}
                                </th>
                              ))}
                        </tr>
                      </thead>

                      <tbody>
                        {data?.locateTransactions?.dsB?.map((item, index) => {
                          const rowHasValue = data?.column2?.some(
                            (col) =>
                              item[col.dataField] !== "N/A" &&
                              item[col.dataField] !== undefined &&
                              item[col.dataField] !== null
                          );
                          if (!rowHasValue) {
                            return null;
                          }

                          return (
                            <tr key={`dsb-original-${index}`}>
                              <td></td>
                              {data?.column2?.map(({ text, dataField }) => {
                                const value = item[dataField];
                                const isAmount = text === "Amount" && value;
                                const formattedValue = isAmount
                                  ? formatNumber(value)
                                  : value;
                                return (
                                  <td
                                    key={dataField}
                                    className={isAmount ? "text-right" : ""}
                                    style={
                                      selectedColumnsDSB.includes(dataField)
                                        ? { backgroundColor: "#f5f6f7" }
                                        : {}
                                    }
                                  >
                                    {formattedValue ?? ""}
                                  </td>
                                );
                              })}
                            </tr>
                          );
                        })}
                        {searchedTransactionDSB?.length > 0 &&
                          searchedTransactionDSB?.map((item, index) => (
                            <tr key={`dsb-searched-${index}`}>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={_.isEqual(
                                    selectedTransactionDSB?.[0],
                                    item
                                  )}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setSelectedTransactionDSB([item]);
                                    } else {
                                      setSelectedTransactionDSB([]);
                                    }
                                  }}
                                />
                              </td>
                              {searchedHeaderDSB?.map((header) => {
                                if (header?.toLowerCase() === "raw data") {
                                  const rawDataContent = item[header];
                                  const parsedPreview =
                                    parseRawData(rawDataContent);
                                  const displayContent =
                                    parsedPreview.length > 50
                                      ? parsedPreview.substring(0, 50) + "..."
                                      : parsedPreview;

                                  return (
                                    <td
                                      key={header}
                                      style={
                                        selectedColumnsDSB.includes(
                                          data?.column2?.find(
                                            (col) => col?.text === header
                                          )?.dataField
                                        )
                                          ? { backgroundColor: "#f5f6f7" }
                                          : {}
                                      }
                                    >
                                      {displayContent ? (
                                        <OverlayTrigger
                                          trigger="click"
                                          placement="left"
                                          overlay={
                                            <Popover id="popover-basic">
                                              <RawDataTooltip
                                                rawData={rawDataContent}
                                              />
                                            </Popover>
                                          }
                                          rootClose
                                        >
                                          <Button
                                            variant="link"
                                            className="p-0 text-left raw-data-preview"
                                            style={{
                                              textDecoration: "none",
                                              color: "#007bff",
                                              cursor: "pointer",
                                              fontSize: "12px",
                                              fontFamily: "monospace",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              maxWidth: "200px",
                                              display: "block",
                                            }}
                                          >
                                            {displayContent}
                                          </Button>
                                        </OverlayTrigger>
                                      ) : (
                                        "-"
                                      )}
                                    </td>
                                  );
                                } else {
                                  return (
                                    <td
                                      key={header}
                                      style={
                                        selectedColumnsDSB.includes(
                                          data?.column2?.find(
                                            (col) => col?.text === header
                                          )?.dataField
                                        )
                                          ? { backgroundColor: "#f5f6f7" }
                                          : {}
                                      }
                                    >
                                      {item[header] || "-"}
                                    </td>
                                  );
                                }
                              })}
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                )}
                <div className="d-flex justify-content-end mt-4">
                  <div className="col-8">
                    <div className="row text-right">
                      {data?.allowAccountEntries && difference !== 0 && (
                        <button
                          className="btn btn-info ml-3 btn-md"
                          onClick={() => {
                            const removeRawDataField = (txns) =>
                              txns?.map((txn) => {
                                return Object.fromEntries(
                                  Object.entries(txn).filter(
                                    ([key]) => key.toLowerCase() !== "raw data"
                                  )
                                );
                              }) || [];

                            setPresistState({
                              manualMatchState: {
                                showAdjustmentModal: true,
                                searchedHeaderDSA: searchedHeaderDSA?.filter(
                                  (header) =>
                                    header.toLowerCase() !== "raw data"
                                ),
                                searchedHeaderDSB: searchedHeaderDSB?.filter(
                                  (header) =>
                                    header.toLowerCase() !== "raw data"
                                ),
                                selectedTransactionDSA: removeRawDataField(
                                  selectedTransactionDSA
                                ),
                                selectedTransactionDSB: removeRawDataField(
                                  selectedTransactionDSB
                                ),
                                notes,
                              },
                            });

                            resetDSASearch();
                            resetDSBSearch();
                            setSelectedTransactionDSA([]);
                            setSelectedTransactionDSB([]);
                            setDifference(0);
                            setTotal(0);
                            setShowModal(false);
                          }}
                        >
                          Match with Adjustment
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="row text-right">
                      <div className="col-6">Total</div>
                      <div className="col-6">{total}</div>
                    </div>
                    <div className="row text-right">
                      <div className="col-6">Difference</div>
                      <div className="col-6">{difference}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-4">
            <div className="notes-wrapper" style={{ height: "550px" }}>
              <h5 className="mb-3 color-gray-dim">Notes</h5>
              <div
                className="overflow-auto fancy-scroll"
                style={{ height: "22em" }}
              >
                <div className="mt-2">
                  {data?.notes?.map(({ author, comment, date, time }, i) => (
                    <ul className="rs-notes-container" key={i}>
                      <li className="rs-notes-item">
                        <h6>{author}</h6>
                        <div className="note-comment">{comment}</div>
                        <sub>
                          {date} {time}
                        </sub>
                      </li>
                    </ul>
                  ))}
                  {notes?.map(({ author, comment, date, time }, i) => (
                    <ul className="rs-notes-container" key={i}>
                      <li className="rs-notes-item">
                        <h6>{author}</h6>
                        <div className="note-comment">{comment}</div>
                        <sub>
                          {date} {time}
                        </sub>
                      </li>
                    </ul>
                  ))}
                </div>
              </div>
              <textarea
                placeholder="Write a Note"
                rows="3"
                id="note"
                className="textArea"
              ></textarea>
              <div className="w-100 mt-2">
                <ButtonBasic
                  classes={"primary px-4 w-100"}
                  title={"Add Notes"}
                  onClick={() => addNote()}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex">
          <ButtonBasic
            title="Cancel"
            onClick={() => {
              resetDSASearch();
              resetDSBSearch();
              setSelectedTransactionDSA([]);
              setSelectedTransactionDSB([]);
              setDifference(0);
              setTotal(0);
              setShowModal(false);
            }}
          />

          <CustomTooltip
            placement="top"
            tooltipId="button-tooltip-3"
            disabled={!isSaveEnabled()}
            disabledMessage={getDisabledMessage()}
            onClick={() => bindLocatedTransaction()}
            buttonText="Save"
          >
            Save
          </CustomTooltip>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default LocateTransactionModal;
